/* eslint-disable jira/filename-case */

import type { TaskList, Cards } from '../../../../common/types.tsx';
import { PLAN_TASK_LIST, PLAN_TASK_VARIANTS } from './constants.tsx';

export const PLAN: {
	readonly taskList: TaskList;
	readonly taskVariants: Cards;
} = {
	taskList: PLAN_TASK_LIST,
	taskVariants: PLAN_TASK_VARIANTS,
} as const;
